/* eslint-disable react-hooks/exhaustive-deps */
import styles from './PayModal.module.less'
import { Modal, Spin, QRCode, Typography } from 'antd'
import { CloseOutlined } from '@ant-design/icons'
import { commonUtils } from '@/helpers/commonUtils'
import classNames from 'classnames'
import { useEffect } from 'react'
import { useState } from 'react'
import { api } from '@/helpers/api'
import { payService } from '@/services/payService'
import { userService } from '@/services/userService/userService'
import { IconImage } from '@/components/Icon/Icon'

export interface PayModalProps {
  visible: boolean
  goodsDetail?: DataModels.goods.CourseMaterialDetail
  resourceId?: string
  onClose: () => void
  onPaySuccess: (goodsName: string) => void
}

const featureMap = [
  {
    title: '包含 {0} 套精编课件',
    gift: ['配套教学设计'],
    service: null,
  },
  {
    title: '包含 {0} 套精编课件',
    gift: ['全套教学设计', '单元复习课件', '期中/期末课件'],
    service: '客服答疑',
  },
  {
    title: '包含 {0} 套精编课件',
    gift: ['全套教学设计', '单元复习课件', '期中/期末课件', '教辅资料'],
    service: '专属人工客服答疑',
  },
  {
    title: '包含 {0} 套精编课件',
    gift: ['全套教学设计', '单元复习课件', '期中/期末课件', '教辅资料'],
    service: '专属人工客服答疑',
  },
]

const modalMap = {
  4: { width: 935, class: styles.four },
  3: { width: 779, class: styles.three },
  2: { width: 773, class: styles.two },
}

// 使用antd的Modal组件
const PayModal: React.FC<PayModalProps> = ({
  visible,
  onClose,
  goodsDetail,
  resourceId,
  onPaySuccess,
}) => {
  const [checked, setChecked] = useState<DataModels.goods.CourseMaterialPriceInfo>(
    {} as DataModels.goods.CourseMaterialPriceInfo
  )
  const [qrCode, setQrCode] = useState('')
  const [plans, setPlans] = useState<DataModels.goods.CourseMaterialPriceInfo[]>([])
  const [createOrderIng, setCreateOrderIng] = useState(false)
  const [modalType, setModalType] = useState(modalMap[2])
  const [feature, setFeature] = useState(featureMap[0])
  const [chargeChannel, setChargeChannel] = useState<'wx_pub_qr' | 'alipay_qr'>('wx_pub_qr')

  useEffect(() => {
    payService.stopCheckPayStatus()
    if (!goodsDetail || !visible) return
    api.goods
      .getCourseMaterialPriceInfo(goodsDetail.goodsId, goodsDetail.goodsType, resourceId)
      .then(({ data }) => {
        const idx = Math.min(data.length - 1, 3)
        setPlans(data)
        setChecked(data[idx])
        setFeature(featureMap[idx] ?? featureMap.at(-1))
        setModalType(modalMap[Math.min(Math.max(data.length, 2), 4) as keyof typeof modalMap])
      })

    userService.postUserActionRecord({
      module: 'PC端官网',
      function: '付费弹窗',
      position: '触发付费弹窗',
      action: '展示',
      element: '页面',
    })
  }, [goodsDetail, visible])

  const parseCurrency = (price?: number) => {
    if (typeof price === 'number') {
      return commonUtils.parseCurrency(price)
    }
    return '-'
  }

  useEffect(() => {
    if (plans.length > 0 && checked?.goodsId) {
      createOrder()
    }
  }, [plans, checked, chargeChannel])

  const createOrder = async () => {
    setCreateOrderIng(true)

    await payService.createPayQrCode({
      goodsId: checked?.goodsId,
      goodsType: checked?.goodsType,
      chargeChannel,
      cb: (codeUrl: string) => {
        setQrCode(codeUrl)
        setCreateOrderIng(false)
      },
      onPaySuccess: () => {
        onPaySuccess(checked?.goodsName)
        onClose()
      },
    })
  }

  const handlePlanChange = (item: DataModels.goods.CourseMaterialPriceInfo, idx: number) => {
    setChecked(item)
    setFeature(featureMap[idx] ?? featureMap.at(-1))
  }

  return (
    <Modal
      open={visible}
      footer={null}
      closable={true}
      closeIcon={<CloseOutlined />}
      onCancel={onClose}
      width={modalType.width}
      centered
      title={null}
      styles={{
        body: {
          padding: 0,
        },
        content: {
          padding: 0,
          overflow: 'hidden',
          borderRadius: 28,
        },
      }}
    >
      <div className={styles.payModal} style={{ width: modalType.width }}>
        <div className={styles.leftPanel}>
          <img
            className={styles.leftPanelBg}
            src={commonUtils.getStaticFile('pc/pay/bg__left.png')}
            alt='一起课件'
          />
          <div className={styles.logo}>
            <img src={commonUtils.getStaticFile('logo-new.png')} alt='一起课件' />
          </div>
          <img
            className={styles.icon1}
            src={commonUtils.getStaticFile('pc/pay/icon__lingxing.png')}
            alt='一起课件'
          />
          <img
            className={styles.icon2}
            src={commonUtils.getStaticFile('pc/pay/icon__lingxing.png')}
            alt='一起课件'
          />
          <img
            className={styles.icon3}
            src={commonUtils.getStaticFile('pc/pay/icon__path.png')}
            alt='pc/pay/icon__path'
          />
          <div className={styles.leftPanelSlogen}>专注专业教学课件研发</div>
          <div className={styles.features}>
            <div className={styles.featuresTitle}>会员权益</div>
            <div className={styles.featuresContent}>
              <div
                className={styles.featuresContentItem}
                dangerouslySetInnerHTML={{
                  __html: commonUtils.stringFormat(
                    feature.title,
                    `<span style="color: #FF7307; font-weight: bold">${
                      checked?.couresCount ?? 1
                    }</span>`
                  ),
                }}
              />
              <div className={classNames(styles.featuresContentItem, styles.gift)}>
                <div className={styles.listTitle}>赠送：</div>
                <div className={styles.list}>
                  {feature.gift.map((item) => (
                    <div key={item} className={styles.listItem}>
                      {item}
                    </div>
                  ))}
                </div>
              </div>
              {feature.service && (
                <div className={styles.featuresContentItem}>{feature.service}</div>
              )}
            </div>
          </div>
        </div>
        <div className={styles.rightPanel}>
          <div className={styles.title}>升级会员</div>
          <div className={classNames(styles.orderPlan, modalType.class)}>
            {plans.map((item, index) => (
              <div
                key={item.goodsId}
                className={classNames(styles.orderPlanItem, {
                  [styles.active]: checked?.goodsId === item.goodsId,
                })}
                onClick={() => handlePlanChange(item, index)}
              >
                <div className={styles.orderPlanItemTitle}>
                  {index === 0 ? '单课件' : item.goodsName}
                </div>
                <div className={styles.orderPlanItemPrice}>
                  <span>¥</span> {parseCurrency(item?.goodsPrice)}
                </div>
                {item?.onePrice && (
                  <div className={styles.orderPlanItemOnePrice}>
                    单课件仅需 <span> {parseCurrency(item?.onePrice)}</span> 元
                  </div>
                )}

                {index === plans.length - 1 && (
                  <img
                    className={styles.recommend}
                    src={commonUtils.getStaticFile('pc/pay/icon__recommend.png')}
                    alt='一起课件'
                  />
                )}
              </div>
            ))}
          </div>
          <div className={styles.title}>会员支付</div>
          <div className={styles.orderPay}>
            <div className={styles.orderQrCode}>
              <Spin spinning={createOrderIng} size='small'>
                <QRCode
                  status={createOrderIng ? 'loading' : 'active'}
                  value={qrCode}
                  size={147}
                  bordered={false}
                  style={{
                    padding: 6,
                    borderRadius: '4px',
                    backgroundColor: 'white',
                    border: '1px solid #EEEEEE',
                  }}
                ></QRCode>
              </Spin>
            </div>
            <div className={styles.orderInfo}>
              <div className={classNames(styles.orderInfoItem)}>
                <div className={styles.label}>支付：</div>
                <div className={styles.payType}>
                  <div
                    className={classNames(styles.payTypeItem, {
                      [styles.active]: chargeChannel === 'wx_pub_qr',
                    })}
                    onClick={() => setChargeChannel('wx_pub_qr')}
                  >
                    <IconImage width={17} height={17} src='IconWepay_1'></IconImage>
                    微信支付
                  </div>
                  <div
                    className={classNames(styles.payTypeItem, {
                      [styles.active]: chargeChannel === 'alipay_qr',
                    })}
                    onClick={() => setChargeChannel('alipay_qr')}
                  >
                    <IconImage width={17} height={17} src='IconAlipay_1'></IconImage>
                    支付宝支付
                  </div>
                </div>
              </div>
              <div className={classNames(styles.orderInfoItem, styles.content)}>
                <div className={styles.label}>内容：</div>
                <div className={styles.value}>
                  <Typography.Text
                    ellipsis={{
                      tooltip: {
                        title: checked?.goodsName,
                        classNames: {
                          root: 'pc-custom-tooltip',
                        },
                      },
                    }}
                  >
                    {checked?.goodsName}
                  </Typography.Text>
                </div>
              </div>
              <div className={classNames(styles.orderInfoItem, styles.price)}>
                <div className={styles.label}>应付：</div>
                <div className={styles.value}>¥{parseCurrency(checked?.goodsPrice)}</div>
              </div>
              <p className={styles.buyTips}>
                <img src={commonUtils.getStaticFile('pc/pay/icon__tips.png')} alt='一起课件' />
                开通后请在一年内及时下载，可提供发票
              </p>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default PayModal
